import { render, staticRenderFns } from "./modalEditarEmpacador.vue?vue&type=template&id=50c37744&scoped=true&"
import script from "./modalEditarEmpacador.vue?vue&type=script&lang=js&"
export * from "./modalEditarEmpacador.vue?vue&type=script&lang=js&"
import style0 from "./modalEditarEmpacador.vue?vue&type=style&index=0&id=50c37744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c37744",
  null
  
)

export default component.exports